import React, { CSSProperties } from 'react';
import HTMLParse from 'html-react-parser';

import * as S from './styled';
import srcIcon from './assets/pin.svg';

interface IProps {
  message: string;
  style?: CSSProperties;
}

const ReusableDate = ({ message, style }: IProps) => (
  <S.Wrapper style={{ ...style }}>
    <S.WrapperImage src={srcIcon} />
    <S.WrapperMessage>{HTMLParse(message)}</S.WrapperMessage>
  </S.Wrapper>
);

export default ReusableDate;
